// @ts-nocheck
import { supabase } from "@/lib/supabase";

/**
 * Ensures the required storage buckets exist
 */
export const ensureStorageBuckets = async () => {
  try {
    // Check if profile-avatars bucket exists, create if not
    try {
      const { data: avatarBuckets, error: avatarCheckError } = await supabase.storage
        .from('profile-avatars')
        .list('', { limit: 1 });
      
      if (avatarCheckError) {
        await supabase.storage.createBucket('profile-avatars', {
          public: true,
          fileSizeLimit: 5 * 1024 * 1024, // 5MB
          allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
        });
        console.log('Created profile-avatars bucket');
      }
    } catch (err) {
      console.log('Creating profile-avatars bucket');
      await supabase.storage.createBucket('profile-avatars', {
        public: true,
        fileSizeLimit: 5 * 1024 * 1024, // 5MB
        allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
      });
    }
    
    // Check if profile-covers bucket exists, create if not
    try {
      const { data: coverBuckets, error: coverCheckError } = await supabase.storage
        .from('profile-covers')
        .list('', { limit: 1 });
      
      if (coverCheckError) {
        await supabase.storage.createBucket('profile-covers', {
          public: true,
          fileSizeLimit: 10 * 1024 * 1024, // 10MB
          allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
        });
        console.log('Created profile-covers bucket');
      }
    } catch (err) {
      console.log('Creating profile-covers bucket');
      await supabase.storage.createBucket('profile-covers', {
        public: true,
        fileSizeLimit: 10 * 1024 * 1024, // 10MB
        allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
      });
    }

    // Check if press-thumbnails bucket exists, create if not
    try {
      const { data: thumbBuckets, error: thumbCheckError } = await supabase.storage
        .from('press-thumbnails')
        .list('', { limit: 1 });
      
      if (thumbCheckError) {
        await supabase.storage.createBucket('press-thumbnails', {
          public: true,
          fileSizeLimit: 5 * 1024 * 1024, // 5MB
          allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
        });
        console.log('Created press-thumbnails bucket');
      }
    } catch (err) {
      console.log('Creating press-thumbnails bucket');
      await supabase.storage.createBucket('press-thumbnails', {
        public: true,
        fileSizeLimit: 5 * 1024 * 1024, // 5MB
        allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
      });
    }

    // Check if press-featured-images bucket exists, create if not
    try {
      const { data: featuredBuckets, error: featuredCheckError } = await supabase.storage
        .from('press-featured-images')
        .list('', { limit: 1 });
      
      if (featuredCheckError) {
        await supabase.storage.createBucket('press-featured-images', {
          public: true,
          fileSizeLimit: 10 * 1024 * 1024, // 10MB
          allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
        });
        console.log('Created press-featured-images bucket');
      }
    } catch (err) {
      console.log('Creating press-featured-images bucket');
      await supabase.storage.createBucket('press-featured-images', {
        public: true,
        fileSizeLimit: 10 * 1024 * 1024, // 10MB
        allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
      });
    }

    // Check if event-thumbnails bucket exists, create if not
    try {
      const { data: eventThumbnailBuckets, error: eventThumbnailCheckError } = await supabase.storage
        .from('event-thumbnails')
        .list('', { limit: 1 });
      
      if (eventThumbnailCheckError) {
        await supabase.storage.createBucket('event-thumbnails', {
          public: true,
          fileSizeLimit: 5 * 1024 * 1024, // 5MB
          allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
        });
        console.log('Created event-thumbnails bucket');
      }
    } catch (err) {
      console.log('Creating event-thumbnails bucket');
      await supabase.storage.createBucket('event-thumbnails', {
        public: true,
        fileSizeLimit: 5 * 1024 * 1024, // 5MB
        allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
      });
    }

    // Check if event-featured bucket exists, create if not
    try {
      const { data: eventFeaturedBuckets, error: eventFeaturedCheckError } = await supabase.storage
        .from('event-featured')
        .list('', { limit: 1 });
      
      if (eventFeaturedCheckError) {
        await supabase.storage.createBucket('event-featured', {
          public: true,
          fileSizeLimit: 10 * 1024 * 1024, // 10MB
          allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
        });
        console.log('Created event-featured bucket');
      }
    } catch (err) {
      console.log('Creating event-featured bucket');
      await supabase.storage.createBucket('event-featured', {
        public: true,
        fileSizeLimit: 10 * 1024 * 1024, // 10MB
        allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
      });
    }

    // Check if event-extras bucket exists, create if not
    try {
      const { data: eventExtrasBuckets, error: eventExtrasCheckError } = await supabase.storage
        .from('event-extras')
        .list('', { limit: 1 });
      
      if (eventExtrasCheckError) {
        await supabase.storage.createBucket('event-extras', {
          public: true,
          fileSizeLimit: 5 * 1024 * 1024, // 5MB
          allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
        });
        console.log('Created event-extras bucket');
      }
    } catch (err) {
      console.log('Creating event-extras bucket');
      await supabase.storage.createBucket('event-extras', {
        public: true,
        fileSizeLimit: 5 * 1024 * 1024, // 5MB
        allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
      });
    }

    // Check if event-spectator-tickets bucket exists, create if not
    try {
      const { data: eventTicketsBuckets, error: eventTicketsCheckError } = await supabase.storage
        .from('event-spectator-tickets')
        .list('', { limit: 1 });
      
      if (eventTicketsCheckError) {
        await supabase.storage.createBucket('event-spectator-tickets', {
          public: true,
          fileSizeLimit: 5 * 1024 * 1024, // 5MB
          allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
        });
        console.log('Created event-spectator-tickets bucket');
      }
    } catch (err) {
      console.log('Creating event-spectator-tickets bucket');
      await supabase.storage.createBucket('event-spectator-tickets', {
        public: true,
        fileSizeLimit: 5 * 1024 * 1024, // 5MB
        allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
      });
    }

    // Check if camp-logos bucket exists, create if not
    try {
      const { data: campLogosBuckets, error: campLogosCheckError } = await supabase.storage
        .from('camp-logos')
        .list('', { limit: 1 });
      
      if (campLogosCheckError) {
        await supabase.storage.createBucket('camp-logos', {
          public: true,
          fileSizeLimit: 5 * 1024 * 1024, // 5MB
          allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
        });
        console.log('Created camp-logos bucket');
      }
    } catch (err) {
      console.log('Creating camp-logos bucket');
      await supabase.storage.createBucket('camp-logos', {
        public: true,
        fileSizeLimit: 5 * 1024 * 1024, // 5MB
        allowedMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
      });
    }
    
    return true;
  } catch (error) {
    console.error('Error ensuring storage buckets:', error);
    return false;
  }
};

/**
 * Helper to upload a profile image to Supabase storage
 */
export const uploadProfileImage = async (
  file: File, 
  userId: string, 
  type: 'avatar' | 'cover'
): Promise<string | null> => {
  try {
    const fileExt = file.name.split('.').pop();
    const fileName = `${userId}-${type}.${fileExt}`;
    const filePath = `${userId}/${fileName}`;
    
    // Upload to the appropriate Supabase Storage bucket
    const bucketName = type === 'avatar' ? 'profile-avatars' : 'profile-covers';
    const { error: uploadError } = await supabase.storage
      .from(bucketName)
      .upload(filePath, file, { upsert: true });
      
    if (uploadError) {
      throw uploadError;
    }
    
    // Get public URL
    const { data } = supabase.storage
      .from(bucketName)
      .getPublicUrl(filePath);
      
    return data.publicUrl;
  } catch (error) {
    console.error(`Error uploading ${type}:`, error);
    return null;
  }
};

/**
 * Helper to upload a camp logo to Supabase storage
 */
export const uploadCampLogo = async (
  file: File, 
  campId: string
): Promise<string | null> => {
  try {
    const fileExt = file.name.split('.').pop();
    const fileName = `${campId}-logo.${fileExt}`;
    const filePath = `camps/${fileName}`;
    
    // Upload to the camp-logos Supabase Storage bucket
    const { error: uploadError } = await supabase.storage
      .from('camp-logos')
      .upload(filePath, file, { upsert: true });
      
    if (uploadError) {
      throw uploadError;
    }
    
    // Get public URL
    const { data } = supabase.storage
      .from('camp-logos')
      .getPublicUrl(filePath);
      
    return data.publicUrl;
  } catch (error) {
    console.error('Error uploading camp logo:', error);
    return null;
  }
};